import React from 'react';
import {
  Steps,
  Button,
  Card,
  Typography,
  Switch,
  Row,
  Col,
  Pagination,
  Input,
  Checkbox,
  Divider,
  Modal,
  Select,
} from 'antd';
import { emptyDatesObject } from '../../../availability_calendar/AvailabilityCalendar';
import {
  DollarOutlined,
  EnvironmentOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import calendarIcon from './images/calendar 44.svg';
import summaryIcon from './images/detail.svg';
import mainlake from './images/exotic_main_lake.png';

import './styles.css';
import { Collapse } from 'react-collapse';
import { useState } from 'react';
import tick from './images/check 1.svg';
import bedIcon from './images/bed 1.svg';
import boxIcon from './images/box 1.svg';
import fishIcon from './images/fishing 1.svg';
import userIcon from './images/user 1.svg';
import taxiIcon from './images/frontal-taxi-cab 1.svg';
import cross from './images/close 1.svg';
import { ProductItem } from './ProductItem';

import { useEffect } from 'react';
import { StepProgress } from './StepProgress';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import SelectDate from './SelectDate';
import FishingSection from './FishingSection';
import { useReducer } from 'react';

import dayjs from 'dayjs';
import { useGlobalState } from './GlobalState';
import { DatePicker } from '@mui/x-date-pickers';
import { useUpdateReservationCostMutation } from '../../../admin/components/reservations/reservationSlice';
import { usePostReservationBookingMutation } from '../../../admin/components/quote/membersSlice';
import { notification } from '../../../../utils/messaging';
import { useGetLakeswithTypesQuery } from '../../../admin/components/settings/settingsSlice';
import { useHistory, useParams } from 'react-router';
import {
  useGetAddOnsQuery,
  useGetCustomPropertiesQuery,
} from '../../../admin/components/bookings/bookingSlice';
import { useGetPackagesDetailsByIdQuery } from '../packageSlice';

const initialState = {
  accomodation: {
    include: '',
    guests: { adults: 0, children: 0 },
    rooms: [],
    completed: false,
  },
  fishing: {
    include: '',
    lake: '',
    angler: 0,
    swims: 0,
    fishing_days: 0,
    dates: [],
    completed: false,
  },
  taxi: {
    include: '',
    pickupDateTime: null,
    pickupLocation: '',
    dropoffDateTime: null,
    dropoffLocation: '',
    infoNotAvailable: false,
    completed: false,
  },
  add_ons: {
    include: '',
    user_amount: 0,
    completed: false,
  },
  guest_details: {
    title: '',
    nationality: '',
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    notes: '',
    terms: false,
    completed: false,
  },
};

function reducer(state, action) {
  if (action.type === 'RESET') {
    return initialState;
  }
  if (action.section === null && typeof action.value === 'object') {
    return {
      ...state,
      ...action.value,
    };
  }
  if (action.path) {
    const keys = action.path.split('.');
    const newState = { ...state };
    let curr = newState;
    for (let i = 0; i < keys.length - 1; i++) {
      curr[keys[i]] = { ...curr[keys[i]] };
      curr = curr[keys[i]];
    }
    curr[keys[keys.length - 1]] = action.value;
    return newState;
  }
  return {
    ...state,
    [action.section]: { ...state[action.section], ...action.value },
  };
}
const { Option } = Select;
const PackageBooking = () => {
  const history = useHistory();
  const fisheryId = useParams()['fishery_id'];
  const packageId = useParams()['package_id'];
  const { data: packages } = useGetPackagesDetailsByIdQuery(
    { fishery_id: fisheryId, package_id: packageId },
    {
      skip: !fisheryId || !packageId,
    }
  );

  const [value, setValue] = useState('yes');
  const [collapseVisible, setCollapseVisible] = useState('user');
  const [cartItems, setCartItems] = useState([]);

  const [addedItems, setAddedItems] = useState([]);
  const [cost, setCost] = useState();
  //   const [isOverlayActive, setOverlayActive] = useState(true);
  const [accommodationBookingDates, setAccommodationBookingDates] = useState([
    { ...emptyDatesObject },
  ]);
  const [packageData, setPackageData] = useGlobalState('packageData');
  const [total, setTotal] = useState(0);
  const [isTaxi, setIsTaxi] = useState('no');
  const [isDropoffTaxi, setIsDropoffTaxi] = useState('no');
  useEffect(() => {
    if (packages) setPackageData(packages?.[0]);
  }, [packages]);

  const { data: lakes } = useGetLakeswithTypesQuery(fisheryId);
  const [formData, dispatch] = useReducer(reducer, initialState);
  const [customPropertyDetails, setCustomPropertyDetails] = useGlobalState(
    'customPropertyDetails'
  );

  const handleSetValue = (section, value) => {
    dispatch({ section, value: { include: value } });
  };

  const handleChange = (pathOrSection, value) => {
    if (pathOrSection.includes('.')) {
      dispatch({ path: pathOrSection, value });
    } else {
      dispatch({ section: pathOrSection, value });
    }
  };
  const countCompletedSections = Object.values(formData).filter(
    (section) => section && section.completed === true
  ).length;

  const renderOptions = (section) => {
    return ['yes', 'no'].map((opt) => (
      <div
        key={opt}
        onClick={() => {
          if (opt === 'yes') {
            if (formData[section]?.include == 'no') {
              handleChange(section, {
                completed: false,
              });
            }
            handleSetValue(section, opt);
            setCollapseVisible(section);
          } else {
            setCollapseVisible('');
            if (section === 'accomodation') {
              if (!packageData?.has_accommodation) {
                const rooms = AccommodationLake.booking_types.map((type) => ({
                  product_id: type.id,
                  name: type.name,
                  quantity: 0,
                }));
                handleChange('accomodation', {
                  include: 'no',
                  guests: { adults: 0, children: 0 },
                  rooms: rooms,
                  completed: true,
                });
                setAccommodationBookingDates([{ ...emptyDatesObject }]);
                setCollapseVisible('');
                handleSetValue(section, opt);
              }
            } else if (section === 'fishing') {
              if (!packageData?.supports_fishing) {
                handleChange('fishing', {
                  lakes: '',
                  angler: 0,
                  swims: 0,
                  fishing_days: 0,
                  completed: true,
                });
                setCollapseVisible('');
                handleSetValue(section, opt);
              }
            } else if (section === 'taxi') {
              handleChange('taxi', {
                pickupDateTime: null,
                pickupLocation: '',
                dropoffDateTime: null,
                dropoffLocation: '',
                infoNotAvailable: false,
                completed: true,
              });
              handleSetValue(section, opt);
              setCollapseVisible('');
            } else if (section === 'add_ons') {
              const updatedArray = ProductsData?.map((item) => {
                return {
                  ...item,
                  quantity: 0,
                };
              });

              setCartItems(updatedArray);
              setAddedItems([]);
              setCollapseVisible('guest_details');
              handleSetValue(section, opt);
              handleChange('add_ons', {
                completed: true,
              });
            }
          }
          // handleSetValue(section, opt);
        }}
        className='gSemiBold'
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '4px 8px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
        }}
      >
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: 4,
            background:
              formData[section].include === opt
                ? opt === 'yes'
                  ? '#249968'
                  : '#B22727'
                : '#EAEAEA',
          }}
          className='center justify-center'
        >
          <img alt='viewIcon' src={opt === 'yes' ? tick : cross} />
        </div>
        {opt.charAt(0).toUpperCase() + opt.slice(1)}
      </div>
    ));
  };

  const AccommodationLake = lakes?.find(
    (lake) => lake?.lake_type === 'accommodation'
  );
  let taxiDisabled =
    !formData?.taxi?.infoNotAvailable &&
    (!formData?.taxi?.pickupDateTime ||
      !formData?.taxi?.pickupLocation ||
      !formData?.taxi?.dropoffDateTime ||
      !formData?.taxi?.dropoffLocation);
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  let guestDisabled =
    !formData?.guest_details?.first_name ||
    !formData?.guest_details?.last_name ||
    !formData?.guest_details?.email ||
    !isValidEmail(formData?.guest_details?.email) || // ⬅️ Email format check
    !formData?.guest_details?.terms;

  useEffect(() => {
    if (guestDisabled) {
      dispatch({
        section: 'guest_details',
        value: { completed: false },
      });
    }
  }, [guestDisabled]);
  const { data: ProductsData } = useGetAddOnsQuery(
    {
      fisheryId: fisheryId,
      lakeId: [
        formData?.accomodation?.include === 'yes'
          ? AccommodationLake?.lake_id
          : null,
        formData?.fishing?.lake,
      ].join(','),
    },
    { skip: !fisheryId }
  );
  const { data: customProperties } = useGetCustomPropertiesQuery(
    {
      fisheryId: fisheryId,

      lakeId: [
        formData?.accomodation?.include === 'yes'
          ? AccommodationLake?.lake_id
          : null,
        formData?.fishing?.lake,
      ].join(','),
    },
    {
      skip: !fisheryId,
    }
  );
  useEffect(() => {
    let updatedProperties = customProperties?.map((item) => {
      const existingItem = customPropertyDetails?.find(
        (detail) => detail.field_name === item.field_name
      );

      return {
        ...item,
        field_value: existingItem ? existingItem.field_value : '',
      };
    });

    setCustomPropertyDetails(updatedProperties);
  }, [customProperties]);
  const hasAddonQuantity = addedItems.some((item) => item.quantity > 0);
  const allCompleted = Object.values(formData).every(
    (section) => section?.completed === true
  );

  useEffect(() => {
    if (AccommodationLake?.booking_types && !packageData) {
      const rooms = AccommodationLake.booking_types.map((type) => ({
        product_id: type.id,
        name: type.name,
        quantity: 0,
      }));
      dispatch({ section: 'accomodation', value: { rooms } });
      setCollapseVisible('');
    }
  }, [lakes]);

  const handleRoomChange = (product_id, delta) => {
    const adults = formData.accomodation.guests.adults;
    const minRooms = Math.ceil(adults / 2);
    const maxRooms = adults;

    const updatedRooms = formData.accomodation.rooms.map((room) => {
      if (room.product_id === product_id) {
        const newQuantity = room.quantity + delta;

        // Prevent negative room quantity
        return {
          ...room,
          quantity: Math.max(0, newQuantity),
        };
      }
      return room;
    });

    const newTotal = updatedRooms.reduce((sum, room) => sum + room.quantity, 0);

    // Apply only if total rooms stay within valid range
    if (newTotal <= maxRooms) {
      dispatch({
        section: 'accomodation',
        value: { rooms: updatedRooms, completed: false },
      });

      setAccommodationBookingDates([{ ...emptyDatesObject }]);
    }
  };

  const handleGuestChange = (type, delta) => {
    const newGuests = {
      ...formData.accomodation.guests,
      [type]: Math.max(0, formData.accomodation.guests[type] + delta),
    };
    dispatch({ section: 'accomodation', value: { guests: newGuests } });
    setAccommodationBookingDates([{ ...emptyDatesObject }]);
  };
  const formatDatesByMonth = (dates) => {
    const suffix = (d) => {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    const sortedDates = dates.map((d) => dayjs(d)).sort((a, b) => a - b);

    const grouped = {};

    sortedDates.forEach((date) => {
      const month = date.format('MMMM');
      const day = `${date.date()}${suffix(date.date())}`;
      if (!grouped[month]) grouped[month] = [];
      grouped[month].push(day);
    });

    return Object.entries(grouped)
      .map(([month, days]) => `${days.join(', ')} ${month}`)
      .join(' - ');
  };

  const start = accommodationBookingDates?.[0]?.startDate;
  const end = accommodationBookingDates?.[0]?.endDate;
  const accommodation_days =
    start && end ? Math.max(1, dayjs(end).diff(dayjs(start), 'day')) : 0;
  const totalRooms = formData.accomodation.rooms.reduce(
    (sum, room) => sum + room.quantity,
    0
  );

  const minRooms = Math.ceil(formData.accomodation.guests.adults / 2);
  const maxRooms = formData.accomodation.guests.adults;
  const [getCost] = useUpdateReservationCostMutation();
  const [postBooking, { isLoading: postLoading }] =
    usePostReservationBookingMutation();

  const updateCost = () => {
    let payload = {
      lake_id: formData?.fishing?.lake ?? '',
      package_id: packageData?.id ?? '',
      accommodation_lake_id:
        formData.accomodation.include === 'yes'
          ? AccommodationLake?.lake_id
          : '',
      taxi_information: {
        taxi_booked: formData?.taxi?.include === 'yes',
        pickup_date: formData?.taxi?.pickupDateTime || '',
        pickup_taxi: isTaxi === 'yes',
        dropoff_taxi: isDropoffTaxi === 'yes',
        pickup_location: formData?.taxi?.pickupLocation || '',
        dropoff_date: formData?.taxi?.dropoffDateTime || '',
        dropoff_location: formData?.taxi?.dropoffLocation || '',
      },
      accommodation: formData.accomodation.include === 'yes',
      accommodation_days: accommodation_days,
      accommodation_details: formData.accomodation.rooms
        .filter((room) => room.quantity > 0)
        .map((room) => ({
          ticket_type_id: room.product_id,
          quantity: room.quantity,
          arrival_date:
            (accommodationBookingDates?.[0]?.startDate &&
              dayjs(accommodationBookingDates?.[0]?.startDate).isValid() &&
              dayjs(accommodationBookingDates?.[0]?.startDate).format(
                'YYYY-MM-DD'
              )) ||
            '',
          departure_date:
            (accommodationBookingDates?.[0]?.endDate &&
              dayjs(accommodationBookingDates?.[0]?.endDate).isValid() &&
              dayjs(accommodationBookingDates?.[0]?.endDate).format(
                'YYYY-MM-DD'
              )) ||
            '',
        })),
      arrival_timestamp:
        (accommodationBookingDates?.[0]?.startDate &&
          dayjs(accommodationBookingDates?.[0]?.startDate).isValid() &&
          dayjs(accommodationBookingDates?.[0]?.startDate).format(
            'YYYY-MM-DD'
          )) ||
        '',
      departure_timestamp:
        (accommodationBookingDates?.[0]?.endDate &&
          dayjs(accommodationBookingDates?.[0]?.endDate).isValid() &&
          dayjs(accommodationBookingDates?.[0]?.endDate).format(
            'YYYY-MM-DD'
          )) ||
        '',
      fishing_days: formData?.fishing?.dates ?? [],
      fishing: formData.fishing.include === 'yes',
      num_anglers: formData.fishing.angler || 0,
      num_swims: formData.fishing.swims || 0,
      num_fishing_days: formData.fishing.fishing_days || 0,
      angler_details: [
        {
          first_name: formData.guest_details.first_name || '',
          last_name: formData.guest_details.last_name || '',
          email: formData.guest_details.email || '',
          phone_number: formData.guest_details.phone_number || '',
        },
      ],
      booking_type: '',
      apply_promotion: false,
      add_on_details: (addedItems || [])
        .filter((addOn) => addOn.quantity > 0)
        .map((addOn) => ({
          product_id: addOn.product_id,
          quantity: addOn.quantity,
        })),
      custom_slot_id: '',
    };
    getCost(payload)
      .unwrap()
      .then((v) => {
        setCost(v);
      });
  };
  useEffect(() => {
    if (!packageData) return;

    const {
      lake_id,
      has_accommodation,
      no_of_rooms,
      supports_fishing,
      number_of_fishing_days,
      package_occupants,
      add_ons,
    } = packageData;

    // Prepare rooms data
    const rooms = no_of_rooms?.map((room) => ({
      product_id: room.ticket_type_id,
      name: room.name,
      quantity: room.quantity || 0,
    }));

    // Prepare add-ons data
    const addOnDetails = add_ons?.add_on_details?.map((addOn) => ({
      product_id: addOn.product_id,
      name: addOn.name,
      quantity: addOn.quantity || 0,
      price: addOn.price,
    }));

    dispatch({
      section: null,
      value: {
        accomodation: {
          include: has_accommodation ? 'yes' : 'no',
          rooms: rooms || [],
          guests: {
            adults: package_occupants.adults,
            children: package_occupants.children,
          },
          completed: !has_accommodation,
        },
        fishing: {
          include: supports_fishing ? 'yes' : 'no',
          fishing_days: number_of_fishing_days,

          lake: lake_id,
          angler: packageData?.fishing_details?.no_of_anglers,
          swims: packageData?.fishing_details?.no_of_swims,
          dates: [],
          completed: !supports_fishing,
        },
        add_ons: {
          include: addOnDetails?.length ? 'yes' : 'no',
        },
      },
    });
  }, [packageData]);
  useEffect(() => {
    updateCost();
  }, [
    formData?.fishing?.swims,
    formData?.fishing?.fishing_days,
    addedItems,
    accommodationBookingDates?.[0]?.startDate,
    accommodationBookingDates?.[0]?.endDate,
  ]);
  useEffect(() => {
    if (!packageData) {
      handleChange('fishing', {
        lake: '',
        swims: 0,
        angler: 0,
        fishing_days: 0,
        dates: [],
      });
    }
  }, [formData?.accomodation?.include]);

  const postBookingRequest = () => {
    let payload = {
      arrival_timestamp: '',
      departure_timestamp: '',
      guest: formData?.accomodation?.guests?.adults ?? 0,
      anglers: formData?.fishing?.angler || 0,
      amount: cost?.pricing_details?.pricing_breakdown?.advance_price,
      total_price: cost?.pricing_details?.pricing_breakdown?.total_price,
      lake_id: formData?.fishing?.lake ?? '',
      accommodation_lake_id:
        formData.accomodation.include === 'yes'
          ? AccommodationLake?.lake_id
          : '',
      is_admin_booking_or_editing: false,
      swims: [],
      details: {
        angler_details: [
          {
            first_name: formData?.guest_details?.first_name || '',
            title: formData?.guest_details?.title || '',
            nationality: formData?.guest_details?.nationality || '',
            last_name: formData?.guest_details?.last_name || '',
            email: formData?.guest_details?.email || '',
            phone_number: formData?.guest_details?.phone_number || '',
            note: formData?.guest_details?.notes || '',
          },
        ],
      },
      payment_type: '',
      book_lake_exclusive: false,
      use_wallet: false,
      wallet_amount_to_spend: 0,
      add_on_details: addedItems?.filter((item) => item.quantity > 0) || [],
      type: 'package',
      package_id: '',
      has_accommodation: formData?.accomodation?.include === 'yes',
      accommodation_details:
        formData?.accomodation?.rooms?.map((room) => ({
          ticket_type_id: room.product_id,
          quantity: room.quantity,
          arrival_date:
            (accommodationBookingDates?.[0]?.startDate &&
              dayjs(accommodationBookingDates?.[0]?.startDate).isValid() &&
              dayjs(accommodationBookingDates?.[0]?.startDate).format(
                'YYYY-MM-DD'
              )) ||
            '',
          departure_date:
            (accommodationBookingDates?.[0]?.endDate &&
              dayjs(accommodationBookingDates?.[0]?.endDate).isValid() &&
              dayjs(accommodationBookingDates?.[0]?.endDate).format(
                'YYYY-MM-DD'
              )) ||
            '',
        })) || [],
      supports_fishing: formData?.fishing?.include === 'yes',
      custom_properties: customPropertyDetails,
      taxi_information: {
        taxi_booked: formData?.taxi?.include === 'yes',
        pickup_date: formData?.taxi?.pickupDateTime || '',
        pickup_location: formData?.taxi?.pickupLocation || '',
        dropoff_date: formData?.taxi?.dropoffDateTime || '',
        dropoff_location: formData?.taxi?.dropoffLocation || '',
      },
      fishing_details: {
        fishing_dates: formData?.fishing?.dates,
        number_of_fishing_days: formData?.fishing?.fishing_days || 0,
        number_of_swims: formData?.fishing?.swims || 0,
      },
    };

    postBooking(payload)
      .unwrap()
      .then((v) => {
        notification.success({
          description: 'Booking Reservation Send Successfully!',
        });
        resetData();
      });
  };

  useEffect(() => {
    const updatedArray = ProductsData?.map((item) => {
      const matchingItem = packageData?.add_ons?.add_on_details?.find(
        (firstItem) => firstItem?.product_id === item.id
      );

      if (matchingItem) {
        return {
          ...item,
          quantity: matchingItem.quantity,
        };
      }

      return {
        ...item,
        quantity: 0,
      };
    });

    setCartItems(updatedArray);
    if (packageData?.add_ons?.add_on_details?.length) {
      setAddedItems(packageData?.add_ons?.add_on_details);
    } else {
      setAddedItems([]);
    }
  }, [ProductsData, packageData]);

  const handleIncrease = (itemId, quantity, maxQuantity) => {
    if (!maxQuantity || quantity < maxQuantity) {
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item.id === itemId ? { ...item, quantity: item.quantity + 1 } : item
        )
      );

      setAddedItems((prevAddedItems) => {
        const existingItem = prevAddedItems.find(
          (item) => item.product_id === itemId
        );

        if (existingItem) {
          return prevAddedItems.map((item) =>
            item.product_id === itemId
              ? {
                  ...(item?.name && { name: item?.name }),
                  ...(item?.price && { price: item?.price }),
                  product_id: item.product_id,

                  quantity: item.quantity + 1,
                }
              : item
          );
        } else {
          const newItem = cartItems.find((item) => item.id === itemId);
          return [
            ...prevAddedItems,
            {
              ...(newItem?.name && { name: newItem?.name }),
              ...(newItem?.price && { price: newItem?.price }),
              product_id: newItem?.id,
              quantity: 1,
            },
          ];
        }
      });
    }
  };

  const handleDecrease = (itemId, quantity) => {
    if (quantity > 0) {
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item.id === itemId && item.quantity > 0
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
      );

      setAddedItems((prevAddedItems) => {
        const existingItem = prevAddedItems.find(
          (item) => item.product_id === itemId
        );

        if (existingItem && existingItem.quantity > 1) {
          return prevAddedItems.map((item) =>
            item.product_id === itemId
              ? {
                  ...(item?.name && { name: item?.name }),
                  ...(item?.price && { price: item?.price }),
                  quantity: item.quantity - 1,
                  product_id: item.product_id,
                }
              : item
          );
        } else {
          return prevAddedItems.filter((item) => item.product_id !== itemId);
        }
      });
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const onChangePagination = (page) => {
    setCurrentPage(page);
  };
  const startIndex = (currentPage - 1) * 8;
  const endIndex = startIndex + 8;
  const totalRoomsBooked = formData.accomodation.rooms.reduce(
    (acc, room) => acc + room.quantity,
    0
  );
  let isOverlayActive =
    formData?.accomodation?.guests?.adults == 0 ||
    totalRoomsBooked == 0 ||
    totalRooms < minRooms ||
    totalRooms > maxRooms;
  const resetData = () => {
    dispatch({ type: 'RESET' });
    setAccommodationBookingDates([{ ...emptyDatesObject }]);
    setAddedItems([]);
  };
  console.log(
    !allCompleted ||
      (formData?.accomodation?.include === 'no' &&
        formData?.fishing?.include === 'no')
    // !allCompleted,
    // formData?.accomodation?.include === 'no' &&
    //   formData?.fishing?.include === 'no'
  );
  return (
    <div className='container-user-reservation'>
      <Row className='w-full justify-center gap-1r'>
        {/* Left Panel */}
        <Col xs={24} sm={24} md={24} lg={16} className='left-panel'>
          <div
            level={4}
            className='sb-blue-bg-700 white gSemiBold fs-20 container-heading  '
          >
            <div className='row-center'>
              <img src={calendarIcon} className='mg-right-10' alt='calendar' />
              <div>New Reservation </div>
            </div>
            <StepProgress
              currentStep={countCompletedSections}
              steps={[1, 2, 3, 4, 5]}
            />
          </div>
          <div
            className='pd-20 justify-between details center w-full'
            // style={{ height: 'calc(100% - 72px)' }}
          >
            <div className='w-full'>
              <div className='individual-container mg-bottom-10'>
                <div
                  className='pd-20  cp'
                  onClick={() => {
                    if (formData?.accomodation?.include === 'yes') {
                      setCollapseVisible('accomodation');
                    }
                  }}
                >
                  <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                    <div className='row-center w-full justify-between flex-wrap gap-05r'>
                      <div className='row-center'>
                        <div
                          className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                          style={{ minWidth: 34, height: 34 }}
                        >
                          <img src={bedIcon} alt='bed-icon' />
                        </div>
                        <div className='row-center  justify-between'>
                          <div className='fs-18 '>Accommodation</div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        {!packageData && (
                          <>
                            <span className='fs-14 gRegular'>
                              Does the reservation include an overnight stay?
                            </span>
                            {renderOptions('accomodation')}
                          </>
                        )}
                        {formData?.accomodation?.completed &&
                          formData?.accomodation?.include === 'yes' && (
                            <div
                              className='cp txt-underline fs-13 gBold grey-800'
                              onClick={() => {
                                setCollapseVisible('accomodation');
                              }}
                            >
                              EDIT
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <Collapse isOpened={collapseVisible === 'accomodation'}>
                  <div className='pd-20'>
                    <Row
                      gutter={[16, 16]}
                      align='middle'
                      className='mg-bottom-20'
                    >
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          flexWrap: 'wrap',
                          rowGap: 10,
                          alignItems: 'center',
                        }}
                      >
                        <Col
                          xs={24}
                          sm={24}
                          xl={11}
                          className='row-center gap-1r flex-wrap'
                        >
                          <div className='gSemiBold sb-blue-900'>
                            No. Of Guests:
                          </div>
                          <div className='display-flex-row flex-wrap gap-1r '>
                            {['adults', 'children'].map((type) => (
                              <div className='display-flex-row' key={type}>
                                <div className='sb-blue-900 gRegular'>
                                  {type === 'adults' ? 'Adult' : 'Child'}
                                </div>
                                <button
                                  className='icon-button'
                                  disabled={
                                    packageData ||
                                    formData.accomodation.guests[type] === 0
                                  }
                                  onClick={() => handleGuestChange(type, -1)}
                                >
                                  <MinusCircleOutlined
                                    style={{
                                      color:
                                        packageData ||
                                        formData.accomodation.guests[type] === 0
                                          ? '#CCD3D9'
                                          : '#5C6166',
                                    }}
                                  />
                                </button>
                                <div>{formData.accomodation.guests[type]}</div>
                                <button
                                  className='icon-button'
                                  disabled={packageData}
                                  onClick={() => handleGuestChange(type, 1)}
                                >
                                  <PlusCircleOutlined
                                    style={{
                                      color: packageData
                                        ? '#CCD3D9'
                                        : '#5C6166',
                                    }}
                                  />
                                </button>
                              </div>
                            ))}
                          </div>
                        </Col>
                        <Col xs={0} sm={0} xl={1}>
                          <Divider
                            type='vertical'
                            style={{
                              height: '2rem',
                              border: '1px solid black',
                            }}
                          />
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          xl={12}
                          className='row-center gap-1r flex-wrap'
                        >
                          <div className='gSemiBold sb-blue-900'>
                            No. Of Rooms:
                          </div>
                          <div className='display-flex-row flex-wrap gap-1r'>
                            {formData.accomodation.rooms.map((room) => (
                              <div
                                className='display-flex-row'
                                key={room.product_id}
                              >
                                <div className='sb-blue-900 gRegular'>
                                  {room.name}
                                </div>
                                <button
                                  className='icon-button'
                                  disabled={
                                    packageData ||
                                    room.quantity <= 0 ||
                                    totalRooms <= minRooms
                                  }
                                  onClick={() =>
                                    handleRoomChange(room.product_id, -1)
                                  }
                                >
                                  <MinusCircleOutlined
                                    style={{
                                      color:
                                        packageData ||
                                        room.quantity <= 0 ||
                                        totalRooms <= minRooms
                                          ? '#CCD3D9'
                                          : '#5C6166',
                                    }}
                                  />
                                </button>
                                <div>{room.quantity}</div>
                                <button
                                  className='icon-button'
                                  disabled={
                                    packageData || totalRooms >= maxRooms
                                  }
                                  onClick={() =>
                                    handleRoomChange(room.product_id, 1)
                                  }
                                >
                                  <PlusCircleOutlined
                                    style={{
                                      color:
                                        packageData || totalRooms >= maxRooms
                                          ? '#CCD3D9'
                                          : '#5C6166',
                                    }}
                                  />
                                </button>
                              </div>
                            ))}
                          </div>
                        </Col>
                      </div>
                      <div className='w-full'>
                        <div
                          className={`fishing-package-overlay ${
                            isOverlayActive ? 'active' : ''
                          }`}
                        >
                          {isOverlayActive && (
                            <div className='overlay-message'>
                              <div className='text fs-18 gSemiBold'>
                                PLEASE COMPLETE THE NO. OF GUESTS AND ROOMS
                                REQUIRED TO SEE AVAILABILITY
                              </div>
                            </div>
                          )}
                          <SelectDate
                            handleChange={handleChange}
                            lake_id={AccommodationLake?.lake_id}
                            bookingDates={accommodationBookingDates}
                            setBookingDates={setAccommodationBookingDates}
                            data={formData.accomodation}
                          />
                        </div>
                      </div>
                      <div className='sb-blue-900 gRegular txt-center w-full'>
                        <span className='gSemiBold'>Check-in</span> is from{' '}
                        <span className='seagreen-600 gSemiBold'>2pm</span> on
                        day of arrival |{' '}
                        <span className='gSemiBold'>Check-out</span> is by{' '}
                        <span className='seagreen-600 gSemiBold'>10am</span> on
                        day of departure
                      </div>
                    </Row>
                    <Row justify='center'>
                      <Button
                        type='primary'
                        disabled={
                          isOverlayActive ||
                          !accommodationBookingDates[0].startDate ||
                          !accommodationBookingDates[0].endDate ||
                          dayjs(accommodationBookingDates[0].startDate).isSame(
                            dayjs(accommodationBookingDates[0].endDate),
                            'day'
                          )
                        }
                        onClick={() => {
                          handleChange('accomodation', {
                            completed: true,
                          });
                          handleChange('fishing', {
                            include: formData?.fishing?.include ?? 'yes',
                          });
                          setCollapseVisible('');
                        }}
                        className={`continue-btn ${
                          isOverlayActive ||
                          !accommodationBookingDates[0].startDate ||
                          !accommodationBookingDates[0].endDate ||
                          dayjs(accommodationBookingDates[0].startDate).isSame(
                            dayjs(accommodationBookingDates[0].endDate),
                            'day'
                          )
                            ? 'grey-bg-300'
                            : 'sb-blue-bg-700'
                        } 
                    sb-blue-bg-700 white
                            fs-18 gSemiBold h-full w-fit`}
                      >
                        Save & Continue
                      </Button>
                    </Row>
                  </div>
                </Collapse>
              </div>
              <div
                className={`individual-container ${
                  !formData?.accomodation?.completed ? 'grey-bg-100' : ''
                } mg-bottom-10`}
              >
                <div
                  className={`pd-20 ${
                    formData?.accomodation?.completed ? 'cp' : ''
                  }`}
                  onClick={() => {
                    if (
                      formData?.fishing?.include === 'yes' &&
                      formData?.accomodation?.completed
                    ) {
                      setCollapseVisible('fishing');
                    }
                  }}
                >
                  <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                    <div
                      className='row-center w-full justify-between flex-wrap gap-05r'
                      //   style={{ flex: 1 }}
                    >
                      <div className='row-center'>
                        <div
                          className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                          style={{ minWidth: 34, height: 34 }}
                        >
                          <img src={fishIcon} alt='bed-icon' />
                        </div>
                        <div className='row-center  justify-between'>
                          <div className='fs-18 '>Fishing</div>
                        </div>
                      </div>
                      {formData?.accomodation?.completed ? (
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          {!packageData && (
                            <>
                              <span className='fs-14 gRegular'>
                                Does this reservation include fishing?
                              </span>
                              {renderOptions('fishing')}
                            </>
                          )}
                          {formData?.fishing?.completed &&
                            formData?.fishing?.include === 'yes' && (
                              <div
                                className='cp txt-underline fs-13 gBold grey-800'
                                onClick={() => {
                                  setCollapseVisible('fishing');
                                }}
                              >
                                EDIT
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className='sb-blue-900 gSemiBold fs-18'>
                          Step 2
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <Collapse isOpened={collapseVisible === 'fishing'}>
                  <div className='pd-20'>
                    <FishingSection
                      lakes={lakes}
                      data={formData}
                      accommodationDates={accommodationBookingDates}
                      setCollapseVisible={setCollapseVisible}
                      handleChange={handleChange}
                    />
                  </div>
                </Collapse>
              </div>
              <div
                className={`individual-container ${
                  !formData?.fishing?.completed ? 'grey-bg-100' : ''
                } mg-bottom-10`}
              >
                <div
                  className={`pd-20 ${
                    formData?.fishing?.completed ? 'cp' : ''
                  }`}
                  onClick={() => {
                    if (
                      formData?.taxi?.include === 'yes' &&
                      formData?.fishing?.completed
                    ) {
                      setCollapseVisible('taxi');
                    }
                  }}
                >
                  <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                    <div className='row-center w-full justify-between flex-wrap gap-05r'>
                      <div className='row-center'>
                        <div
                          className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                          style={{ minWidth: 34, height: 34 }}
                        >
                          <img src={taxiIcon} alt='bed-icon' />
                        </div>
                        <div className='row-center  justify-between'>
                          <div className='fs-18 '>Taxi</div>
                        </div>
                      </div>
                      {formData?.fishing?.completed ? (
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          <span className='fs-14 gRegular'>
                            Does this reservation include taxi’s / transfers?
                          </span>
                          {renderOptions('taxi')}
                          {formData?.taxi?.completed &&
                            formData?.taxi?.include === 'yes' && (
                              <div
                                className='cp txt-underline fs-13 gBold grey-800'
                                onClick={() => {
                                  setCollapseVisible('taxi');
                                }}
                              >
                                EDIT
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className='sb-blue-900 gSemiBold fs-18'>
                          Step 3
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <Collapse isOpened={collapseVisible === 'taxi'}>
                  <div className='pd-20'>
                    <Row
                      gutter={[20, 16]}
                      align='middle'
                      className='mg-bottom-20'
                    >
                      <Col xs={24} sm={24} lg={12}>
                        <div className='display-flex-row mg-bottom-10'>
                          <div
                            className='gSemiBold sb-blue-900'
                            style={{ minWidth: 139 }}
                          >
                            {' '}
                            Add Pickup Taxi:
                          </div>
                          <Select
                            value={isTaxi}
                            onChange={(v) => {
                              setIsTaxi(v);
                            }}
                            className='w-full gLight fs-16'
                            popupClassName={
                              'admin-manage-booking-steps-select-list'
                            }
                          >
                            <Option value={'yes'}>Yes</Option>
                            <Option value={'no'}>No</Option>
                          </Select>
                        </div>
                        <div className='display-flex-row mg-bottom-10'>
                          <div
                            className='gSemiBold sb-blue-900 row-center'
                            style={{ minWidth: 139 }}
                          >
                            {' '}
                            Pickup Date & Time:
                          </div>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              label='Select time'
                              style={{ fontFamily: 'gRegular' }}
                              value={
                                (formData.taxi.pickupDateTime &&
                                  dayjs(formData.taxi.pickupDateTime)) ||
                                null
                              }
                              onChange={(value) => {
                                handleChange(
                                  'taxi.pickupDateTime',
                                  dayjs(value).format('YYYY-MM-DD HH:mm')
                                );
                              }}
                              disabled={isTaxi === 'no'}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  InputLabelProps: { shrink: false }, // Prevent the label from taking up space
                                  sx: {
                                    '.MuiInputLabel-root': {
                                      display: 'none', // Hide label
                                    },
                                    maxWidth: '100%',
                                    float: 'right',
                                    height: '32px', // Set desired height
                                    '.MuiInputBase-root': {
                                      backgroundColor:
                                        isTaxi === 'yes' ? 'white' : '#f5f5f5', // Grey when disabled
                                      marginTop: 0, // Remove top margin
                                      height: '32px', // Adjust height of the input
                                    },
                                  },
                                },
                              }}
                              className='br5 bg-white gRegular w-full  '
                              id='gRegular'
                              format='DD/MM/YYYY HH:mm'
                            ></DateTimePicker>
                          </LocalizationProvider>
                        </div>
                        <div className='display-flex-row'>
                          <div
                            className='gSemiBold sb-blue-900'
                            style={{ minWidth: 139 }}
                          >
                            {' '}
                            Pickup Location:
                          </div>
                          <Input.TextArea
                            value={formData.taxi.pickupLocation || null}
                            onChange={(e) => {
                              handleChange(
                                'taxi.pickupLocation',
                                e.target.value
                              );
                            }}
                            disabled={isTaxi === 'no'}
                          />
                        </div>
                      </Col>
                      <Col xs={24} sm={24} lg={12}>
                        <div className='display-flex-row mg-bottom-10'>
                          <div
                            className='gSemiBold sb-blue-900'
                            style={{ minWidth: 139 }}
                          >
                            {' '}
                            Add Dropoff Taxi:
                          </div>
                          <Select
                            value={isDropoffTaxi}
                            onChange={(v) => {
                              setIsDropoffTaxi(v);
                            }}
                            className='w-full gLight fs-16'
                            popupClassName={
                              'admin-manage-booking-steps-select-list'
                            }
                          >
                            <Option value={'yes'}>Yes</Option>
                            <Option value={'no'}>No</Option>
                          </Select>
                        </div>
                        <div className='display-flex-row mg-bottom-10'>
                          <div
                            className='gSemiBold sb-blue-900 row-center'
                            style={{ minWidth: 139 }}
                          >
                            {' '}
                            Dropoff Date & Time:
                          </div>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              label='Select time'
                              style={{ fontFamily: 'gRegular' }}
                              value={
                                (formData.taxi.dropoffDateTime &&
                                  dayjs(formData.taxi.dropoffDateTime)) ||
                                null
                              }
                              onChange={(value) => {
                                handleChange(
                                  'taxi.dropoffDateTime',
                                  dayjs(value).format('YYYY-MM-DD HH:mm')
                                );
                              }}
                              disabled={isDropoffTaxi === 'no'}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  InputLabelProps: { shrink: false }, // Prevent the label from taking up space
                                  sx: {
                                    '.MuiInputLabel-root': {
                                      display: 'none', // Hide label
                                    },
                                    maxWidth: '100%',
                                    float: 'right',
                                    height: '32px', // Set desired height
                                    '.MuiInputBase-root': {
                                      backgroundColor:
                                        isDropoffTaxi === 'yes'
                                          ? 'white'
                                          : '#f5f5f5', // Grey when disabled
                                      marginTop: 0, // Remove top margin
                                      height: '32px', // Adjust height of the input
                                    },
                                  },
                                },
                              }}
                              className='br5 bg-white gRegular w-full  '
                              id='gRegular'
                              format='DD/MM/YYYY HH:mm'
                            ></DateTimePicker>
                          </LocalizationProvider>
                        </div>
                        <div className='display-flex-row '>
                          <div
                            className='gSemiBold sb-blue-900'
                            style={{ minWidth: 139 }}
                          >
                            {' '}
                            Dropoff Location:
                          </div>
                          <Input.TextArea
                            value={formData.taxi.dropoffLocation || null}
                            onChange={(e) => {
                              handleChange(
                                'taxi.dropoffLocation',
                                e.target.value
                              );
                            }}
                            disabled={isDropoffTaxi === 'no'}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className='mg-top-30 row-center justify-center w-full mg-bottom-30'>
                      <div className='center mg-right-20'>
                        <div className='sb-blue-900 gSemiBold'>
                          I don’t have this information yet
                        </div>
                        <div className='fs-12 gRegular'>
                          (Don’t worry, it can be added later!)
                        </div>
                      </div>
                      <div>
                        <Checkbox
                          checked={formData?.taxi.infoNotAvailable}
                          onChange={(e) => {
                            handleChange('taxi', {
                              infoNotAvailable: e.target.checked,
                              pickupDateTime: '',
                              pickupLocation: '',
                              dropoffDateTime: '',
                              dropoffLocation: '',
                            });
                          }}
                        />
                      </div>
                    </div>
                    <Row justify='center'>
                      <Button
                        type='primary'
                        onClick={() => {
                          handleChange('taxi.completed', true);
                          setCollapseVisible('');
                        }}
                        disabled={taxiDisabled}
                        className={`continue-btn ${
                          taxiDisabled ? 'grey-bg-300' : 'sb-blue-bg-700'
                        } white fs-18 gSemiBold h-full w-fit`}
                      >
                        Save & Continue
                      </Button>
                    </Row>
                  </div>
                </Collapse>
              </div>
              <div
                className={`individual-container ${
                  !formData?.taxi?.completed ? 'grey-bg-100' : ''
                } mg-bottom-10`}
              >
                <div
                  className={`pd-20 ${formData?.taxi?.completed ? 'cp' : ''}`}
                  onClick={() => {
                    if (
                      formData?.add_ons?.include === 'yes' &&
                      formData?.taxi?.completed
                    ) {
                      setCollapseVisible('add_ons');
                    }
                  }}
                >
                  <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                    <div className='row-center w-full justify-between flex-wrap gap-05r'>
                      <div className='row-center'>
                        <div
                          className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                          style={{ minWidth: 34, height: 34 }}
                        >
                          <img src={boxIcon} alt='bed-icon' />
                        </div>
                        <div className='row-center  justify-between'>
                          <div className='fs-18 '>Add-Ons</div>
                        </div>
                      </div>
                      {formData?.taxi?.completed ? (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '8px',
                          }}
                        >
                          <span className='fs-14 gRegular'>
                            Does this reservation include add-ons?
                          </span>
                          {renderOptions('add_ons')}
                          {formData?.add_ons?.completed &&
                            formData?.add_ons?.include === 'yes' && (
                              <div
                                className='cp txt-underline fs-13 gBold grey-800'
                                onClick={() => {
                                  setCollapseVisible('add_ons');
                                }}
                              >
                                EDIT
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className='sb-blue-900 gSemiBold fs-18'>
                          Step 4
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <Collapse isOpened={collapseVisible === 'add_ons'}>
                  <div className='pd-20 pd-top-0'>
                    <Row gutter={[10, 15]}>
                      {cartItems?.slice(startIndex, endIndex)?.map((item) => (
                        <ProductItem
                          key={item?.id}
                          item={item}
                          onIncrease={() =>
                            handleIncrease(
                              item.id,
                              item.quantity,
                              item.max_quantity
                            )
                          }
                          onDecrease={() =>
                            handleDecrease(item.id, item.quantity)
                          }
                        />
                      ))}
                    </Row>
                    {cartItems?.length > 0 && (
                      <Pagination
                        className='mg-top-30  justify-center'
                        current={currentPage}
                        onChange={onChangePagination}
                        total={cartItems?.length}
                        pageSize={8}
                        showSizeChanger={false}
                      />
                    )}
                    <Row justify='center'>
                      <Button
                        type='primary'
                        onClick={() => {
                          handleChange('add_ons.completed', true);
                          setCollapseVisible('guest_details');
                        }}
                        disabled={!hasAddonQuantity}
                        className={`continue-btn ${
                          !hasAddonQuantity ? 'grey-bg-300' : 'sb-blue-bg-700'
                        } white mg-top-20 fs-18 gSemiBold h-full w-fit`}
                      >
                        Save & Continue
                      </Button>
                    </Row>
                  </div>
                </Collapse>
              </div>
              <div
                className={`individual-container ${
                  !formData?.add_ons?.completed ? 'grey-bg-100' : ''
                } mg-bottom-10`}
              >
                <div
                  className={`pd-20 ${
                    formData?.add_ons?.completed ? 'cp' : ''
                  }`}
                  onClick={() => {
                    if (formData?.add_ons?.completed) {
                      setCollapseVisible('guest_details');
                    }
                  }}
                >
                  <div className='fs-18 row-center gSemiBold justify-between mg-bottom-0'>
                    <div className='row-center w-full justify-between flex-wrap gap-05r'>
                      <div className='row-center'>
                        <div
                          className='sb-blue-bg-600 br5 center justify-center mg-right-10'
                          style={{ minWidth: 34, height: 34 }}
                        >
                          <img src={userIcon} alt='user-icon' />
                        </div>
                        <div className='row-center  justify-between'>
                          <div className='fs-18 '>Guest Details</div>
                        </div>
                      </div>
                      {formData?.add_ons?.completed ? (
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          {formData?.guest_details?.completed && (
                            <div className='row-center'>
                              <div className='gBOld seagreen-600 fs-14 mg-right-16'>
                                COMPLETED
                              </div>

                              <div
                                className='cp txt-underline fs-13 gBold grey-800'
                                onClick={() => {
                                  setCollapseVisible('guest_details');
                                }}
                              >
                                EDIT
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className='sb-blue-900 gSemiBold fs-18'>
                          Step 5
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <Collapse isOpened={collapseVisible === 'guest_details'}>
                  <div className='pd-20 pd-top-0'>
                    <div className='mg-bottom-20 gMedium'>
                      <div className='fs-16 sb-blue-900 gSemiBold mg-bottom-20'>
                        Lead Guest Details
                      </div>
                      <Row gutter={[20, 12]} className='mg-bottom-10'>
                        <Col xs={24} sm={24} lg={12}>
                          <Row className='row-center'>
                            <Col span={8} className='sb-blue-900 gSemiBold'>
                              Title
                            </Col>
                            <Col span={16}>
                              <Input
                                style={{ maxWidth: 150 }}
                                className='br5'
                                value={formData?.guest_details?.title}
                                onChange={(e) => {
                                  handleChange(
                                    'guest_details.title',
                                    e.target.value
                                  );
                                }}
                              ></Input>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} sm={24} lg={12}>
                          <Row className='row-center'>
                            <Col span={8} className='sb-blue-900 gSemiBold'>
                              Nationality
                            </Col>
                            <Col span={16}>
                              <Input
                                style={{ maxWidth: 150 }}
                                value={formData?.guest_details?.nationlity}
                                onChange={(e) => {
                                  handleChange(
                                    'guest_details.nationality',
                                    e.target.value
                                  );
                                }}
                                className='br5'
                              ></Input>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={[20, 12]} className='mg-bottom-10'>
                        <Col xs={24} sm={24} lg={12}>
                          <Row className='row-center'>
                            <Col span={8} className='sb-blue-900 gSemiBold'>
                              First Name
                            </Col>
                            <Col span={16}>
                              <Input
                                className='br5'
                                value={formData?.guest_details?.first_name}
                                onChange={(e) => {
                                  handleChange(
                                    'guest_details.first_name',
                                    e.target.value
                                  );
                                }}
                              ></Input>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} sm={24} lg={12}>
                          <Row className='row-center'>
                            <Col span={8} className='sb-blue-900 gSemiBold'>
                              Last Name
                            </Col>
                            <Col span={16}>
                              <Input
                                className='br5'
                                value={formData?.guest_details?.last_name}
                                onChange={(e) => {
                                  handleChange(
                                    'guest_details.last_name',
                                    e.target.value
                                  );
                                }}
                              ></Input>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row gutter={[20, 12]} className='mg-bottom-10'>
                        <Col xs={24} sm={24} lg={12}>
                          <Row className='row-center'>
                            <Col span={8} className='sb-blue-900 gSemiBold'>
                              Email
                            </Col>
                            <Col span={16}>
                              <Input
                                className='br5'
                                value={formData?.guest_details?.email}
                                onChange={(e) => {
                                  handleChange(
                                    'guest_details.email',
                                    e.target.value
                                  );
                                }}
                              ></Input>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={24} sm={24} lg={12}>
                          <Row className='row-center'>
                            <Col span={8} className='sb-blue-900 gSemiBold'>
                              Phone Number
                            </Col>
                            <Col span={16}>
                              <Input
                                className='br5'
                                type='number'
                                value={formData?.guest_details?.phone_number}
                                onChange={(e) => {
                                  handleChange(
                                    'guest_details.phone_number',
                                    e.target.value
                                  );
                                }}
                              ></Input>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                    <div className='mg-bottom-20'>
                      {customPropertyDetails?.length > 0 && (
                        <div className='fs-16 sb-blue-900 gSemiBold mg-bottom-20'>
                          Additional Information
                        </div>
                      )}
                      <Row gutter={[20, 12]} className='mg-bottom-10 gMedium'>
                        {customPropertyDetails?.map((item, i) => (
                          <Col xs={24} sm={24} lg={12}>
                            <Row className='row-center'>
                              <Col span={8} className='sb-blue-900 gSemiBold'>
                                {item?.field_name}
                              </Col>
                              <Col span={16}>
                                {item?.field_type === 'text' ||
                                item?.field_type === 'number' ? (
                                  <Input
                                    type={item?.field_type}
                                    value={item?.field_value}
                                    onChange={(e) => {
                                      const updatedDetails = [
                                        ...customPropertyDetails,
                                      ];
                                      updatedDetails[i] = {
                                        ...updatedDetails[i],
                                        field_value: e.target.value,
                                      };

                                      setCustomPropertyDetails(updatedDetails);
                                    }}
                                  />
                                ) : item?.field_type === 'Dropdown' ? (
                                  <Select
                                    value={item?.field_value}
                                    onChange={(v) => {
                                      const updatedDetails = [
                                        ...customPropertyDetails,
                                      ];
                                      updatedDetails[i] = {
                                        ...updatedDetails[i],
                                        field_value: v,
                                      };
                                      setCustomPropertyDetails(updatedDetails);
                                    }}
                                    className='w-full gLight fs-16'
                                    popupClassName={
                                      'admin-manage-booking-steps-select-list'
                                    }
                                  >
                                    {item?.field_options?.map((id) => {
                                      return <Option value={id}>{id}</Option>;
                                    })}
                                  </Select>
                                ) : item?.field_type === 'note' ? (
                                  <Input.TextArea
                                    value={item?.field_value}
                                    onChange={(e) => {
                                      const updatedDetails = [
                                        ...customPropertyDetails,
                                      ];
                                      updatedDetails[i] = {
                                        ...updatedDetails[i],
                                        field_value: e.target.value,
                                      };
                                      setCustomPropertyDetails(updatedDetails);
                                    }}
                                  />
                                ) : item?.field_type === 'date' ? (
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      label='Select Date'
                                      style={{ fontFamily: 'gRegular' }}
                                      value={
                                        (item?.field_value &&
                                          dayjs(item?.field_value)) ||
                                        null
                                      }
                                      onChange={(value) => {
                                        const updatedDetails = [
                                          ...customPropertyDetails,
                                        ];
                                        updatedDetails[i] = {
                                          ...updatedDetails[i],
                                          field_value:
                                            dayjs(value).format('YYYY-MM-DD'),
                                        };
                                        setCustomPropertyDetails(
                                          updatedDetails
                                        );
                                      }}
                                      slotProps={{
                                        textField: {
                                          size: 'small',
                                          InputLabelProps: { shrink: false }, // Prevent the label from taking up space
                                          sx: {
                                            '.MuiInputLabel-root': {
                                              display: 'none', // Hide label
                                            },

                                            float: 'right',
                                            height: '32px', // Set desired height
                                            '.MuiInputBase-root': {
                                              marginTop: 0, // Remove top margin
                                              height: '32px', // Adjust height of the input
                                            },
                                            // '.MuiOutlinedInput-notchedOutline': {
                                            //   display: 'none',
                                            // },
                                          },
                                        },
                                      }}
                                      className='br5 bg-white gRegular w-full  '
                                      id='gRegular'
                                      format='DD/MM/YYYY'
                                    ></DatePicker>
                                  </LocalizationProvider>
                                ) : (
                                  ''
                                )}
                              </Col>
                            </Row>
                          </Col>
                        ))}
                      </Row>
                    </div>
                    <div className='row-center gap-1r justify-between'>
                      <div>
                        <Checkbox
                          checked={formData?.guest_details.terms}
                          onChange={(e) => {
                            handleChange('guest_details', {
                              terms: e.target.checked,
                            });
                          }}
                          className='gMedium fs-12 sb-blue-900'
                        >
                          I confirm that I have read and understood the terms
                          and conditions of booking and that all info provided
                          is true and accurate.
                        </Checkbox>
                      </div>
                      <Button
                        type='primary'
                        disabled={guestDisabled}
                        className={`continue-btn ${
                          guestDisabled ? 'grey-bg-300' : 'sb-blue-bg-700'
                        } white fs-16 gSemiBold h-full w-fit `}
                        onClick={() => {
                          handleChange('guest_details.completed', true);
                          setCollapseVisible('');
                          updateCost();
                        }}
                        style={{ padding: '5px 30px', marginTop: 0 }}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
            <div className='action-buttons'>
              <div
                type='text'
                className='cancel fs-20 cp  gSemiBold txt-underline'
                onClick={() => {
                  history.goBack();
                  resetData();
                }}
              >
                Cancel
              </div>
              <Row justify='center'>
                <Button
                  type='primary'
                  disabled={
                    !allCompleted ||
                    (formData?.accomodation?.include === 'no' &&
                      formData?.fishing?.include === 'no')
                  }
                  loading={postLoading}
                  onClick={postBookingRequest}
                  className={`continue-btn ${
                    allCompleted &&
                    (formData?.accomodation?.include === 'yes' ||
                      formData?.fishing?.include === 'yes')
                      ? 'sb-blue-bg-700'
                      : 'grey-bg-300'
                  } white custom-width mg-top-0 fs-18 gSemiBold h-full w-fit`}
                >
                  Procced To Payment
                </Button>
              </Row>
            </div>
          </div>
        </Col>

        {/* Right Panel */}
        <Col xs={24} sm={24} md={24} lg={7} className='right-panel'>
          <div
            level={4}
            className='container-heading sb-blue-bg-700 white gSemiBold fs-20'
          >
            <div className='row-center'>
              <img src={summaryIcon} className='mg-right-10' alt='calendar' />
              Summary
            </div>
          </div>
          <div
            className='pd-15 justify-between center w-full'
            style={{ height: 'calc(100% - 72px)' }}
          >
            <div className='summary-container'>
              {/* Image Section */}
              <div className='summary-image'>
                <img src={mainlake} alt='Exotic Fishing Thailand' />
                <div className='summary-title'>Exotic Fishing Thailand</div>
              </div>

              {/* Details Section */}
              <div className='summary-details'>
                {/* Accommodation */}
                <Row className='summary-section gSemiBold sb-blue-900 '>
                  <Col
                    span={24}
                    className='row-center justify-between mg-bottom-15 fs-16 '
                  >
                    <div>Accommodation Included:</div>
                    <div>
                      {formData?.accomodation?.include
                        ?.charAt(0)
                        .toUpperCase() +
                        formData?.accomodation?.include.slice(1) ?? 'No'}
                    </div>
                  </Col>

                  <Col className='details' span={12}>
                    No. Of Adults:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData?.accomodation?.guests?.adults}
                  </Col>

                  <Col className='details' span={12}>
                    No. Of Children:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData?.accomodation?.guests?.children}
                  </Col>

                  <Col className='details' span={12}>
                    No. Of Rooms:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {totalRoomsBooked}
                  </Col>

                  <Col className='details' span={12}>
                    Arrival Date:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {accommodationBookingDates?.[0]?.startDate &&
                      dayjs(accommodationBookingDates?.[0]?.startDate).format(
                        'DD/MM/YYYY'
                      )}
                  </Col>

                  <Col className='details' span={12}>
                    Departure Date:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {accommodationBookingDates?.[0]?.endDate &&
                      dayjs(accommodationBookingDates[0].endDate).isValid() &&
                      dayjs(accommodationBookingDates?.[0]?.endDate).format(
                        'DD/MM/YYYY'
                      )}
                  </Col>
                </Row>

                {/* Fishing */}
                <Row className='summary-section gSemiBold sb-blue-900 '>
                  <Col
                    span={24}
                    className='row-center justify-between mg-bottom-15 fs-16 '
                  >
                    <div>Fishing Included:</div>
                    <div>
                      {formData?.fishing?.include?.charAt(0).toUpperCase() +
                        formData?.fishing?.include.slice(1) ?? 'No'}
                    </div>
                  </Col>
                  <Col className='details' span={12}>
                    No. Of Anglers:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData?.fishing?.angler}
                  </Col>

                  <Col className='details' span={12}>
                    No. Of Swims:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData?.fishing?.swims}
                  </Col>

                  <Col className='details' span={12}>
                    No. Of Fishing Days:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData?.fishing?.fishing_days}
                  </Col>

                  <Col className='details' span={12}>
                    Fishing Dates:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formatDatesByMonth(formData?.fishing?.dates)}
                  </Col>
                </Row>

                <Row className='summary-section gSemiBold sb-blue-900 '>
                  <Col
                    span={24}
                    className='row-center justify-between mg-bottom-15 fs-16 '
                  >
                    <div>Taxi’s Included:</div>
                    <div>
                      {' '}
                      {formData?.taxi?.include?.charAt(0).toUpperCase() +
                        formData?.taxi?.include.slice(1) ?? 'No'}
                    </div>
                  </Col>
                  <Col className='details' span={12}>
                    Pickup Date & Time:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData.taxi.pickupDateTime
                      ? dayjs(formData.taxi.pickupDateTime)
                          .add(30, 'minute') // Add 30 mins to decide rounding
                          .startOf('hour') // Round to nearest hour
                          .format('ha | DD/MM/YYYY')
                      : ''}
                  </Col>

                  <Col className='details' span={12}>
                    Pickup Location:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData.taxi.pickupLocation}
                  </Col>

                  <Col className='details' span={12}>
                    Dropoff Date & Time:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData.taxi.dropoffDateTime
                      ? dayjs(formData.taxi.dropoffDateTime).format(
                          'ha | DD/MM/YYYY'
                        )
                      : ''}
                  </Col>

                  <Col className='details' span={12}>
                    Dropoff Location:
                  </Col>
                  <Col span={12} className='summary-value details'>
                    {formData.taxi.dropoffLocation}
                  </Col>
                </Row>

                {/* Add-ons */}
                <Row className='summary-section gSemiBold sb-blue-900 '>
                  <Col
                    span={24}
                    className='row-center justify-between mg-bottom-15 fs-16 '
                  >
                    <div>Add-Ons:</div>
                    <div>
                      {' '}
                      {formData?.add_ons?.include?.charAt(0).toUpperCase() +
                        formData?.add_ons?.include.slice(1) ?? 'No'}
                    </div>
                  </Col>
                  {addedItems?.map((item, index) => (
                    <Row key={index} className='w-full'>
                      <Col className='details' span={18}>
                        {item.name}
                      </Col>
                      <Col span={6} className='summary-value details'>
                        x{item.quantity}
                      </Col>
                    </Row>
                  ))}
                </Row>
              </div>
            </div>
            <div className='price-container'>
              <div className='price-section sb-blue-900 justify-between'>
                <div className='fs-20 gSemiBold'>Total Price:</div>
                <div className='row-center'>
                  <div className='gSemiBold fs-14 mg-right-5'>(£ GBP)</div>
                  <div
                    className='seagreen-bg-700 br5 white fs-18 gSemiBold pd-left-5 pd-right-5 txt-right'
                    style={{ minWidth: 100 }}
                  >
                    £
                    {cost?.pricing_details?.pricing_breakdown?.total_price ?? 0}
                  </div>
                </div>
              </div>
              <div className='price-section sb-blue-900'>
                <div className='fs-20 gSemiBold center'>
                  Pay Today:
                  <div className='fs-12 gSemiBold'>(30% Deposit)</div>
                </div>
                <div className='row-center'>
                  <div className='gSemiBold fs-14 mg-right-5'>(£ GBP)</div>
                  <div
                    className='seagreen-bg-500 br5 white txt-right fs-18 gSemiBold pd-left-5 pd-right-5'
                    style={{ minWidth: 100 }}
                  >
                    £
                    {cost?.pricing_details?.pricing_breakdown?.advance_price ??
                      0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PackageBooking;
